import { api } from './api';

export interface WorkflowSuggestionDto {
  workflowId?: string | null;
  source?: string;
  workflowName?: string | null;
  ruleLabel?: string | null;
  customerSuggestWorkflowByDefault?: boolean;
}

export interface WorkflowAssociationRuleDto {
  id: string;
  customerId: string;
  workflowId: string;
  workflowName?: string;
  extension?: string | null;
  templateId?: string | null;
  templateName?: string | null;
  folderId?: string | null;
  folderPath?: string | null;
  isActive: boolean;
  createdAt: string;
  updatedAt?: string | null;
}

function omitEmptyParams(params: Record<string, string | undefined>): Record<string, string> {
  const out: Record<string, string> = {};
  for (const [k, v] of Object.entries(params)) {
    if (v !== undefined && v !== null && v !== '') {
      out[k] = v;
    }
  }
  return out;
}

class WorkflowAssociationService {
  async suggestWorkflow(params: {
    customerId: string;
    templateId?: string;
    fileExtension?: string;
    folderId?: string;
  }): Promise<WorkflowSuggestionDto> {
    const q = omitEmptyParams({
      customerId: params.customerId,
      templateId: params.templateId,
      fileExtension: params.fileExtension,
      folderId: params.folderId,
    });
    const { data } = await api.get<WorkflowSuggestionDto>('/workflow-association/suggest', { params: q });
    return data;
  }

  async getRules(customerId: string): Promise<WorkflowAssociationRuleDto[]> {
    const { data } = await api.get<WorkflowAssociationRuleDto[]>('/workflow-association/rules', {
      params: { customerId },
    });
    return data ?? [];
  }

  async createRule(data: {
    customerId: string;
    workflowId: string;
    extension?: string;
    templateId?: string;
    folderId?: string;
    isActive?: boolean;
  }): Promise<string> {
    const body = {
      customerId: data.customerId,
      workflowId: data.workflowId,
      extension: data.extension,
      templateId: data.templateId,
      folderId: data.folderId,
      isActive: data.isActive ?? true,
    };
    const { data: id } = await api.post<string>('/workflow-association/rules', body);
    return id;
  }

  async updateRule(
    id: string,
    data: {
      workflowId: string;
      extension?: string;
      templateId?: string;
      folderId?: string;
      isActive: boolean;
    }
  ): Promise<void> {
    await api.put(`/workflow-association/rules/${id}`, {
      id,
      ...data,
    });
  }

  async deleteRule(id: string): Promise<void> {
    await api.delete(`/workflow-association/rules/${id}`);
  }
}

export const workflowAssociationService = new WorkflowAssociationService();
